module.exports = __webpack_public_path__ + "static/media/dealertrack-logo-v2.156901a3.svg";